import { IAnimalRepository } from '../../../interfaces/gateways/animal.repository'

export default class ToggleContinent {
  constructor (
    private readonly animalRepository: IAnimalRepository
  ) {
  }

  execute (continent: string): void {
    this.animalRepository.toggleContinent(continent)
  }
}
